<template>
  <VRow class="pb-0 mt-2">
    <VCol
      cols="12"
      lg="12"
      md="12"
      sm="12"
      xs="12"
      class="body-2 pt-0"
    >
      <div
        v-if="!isEditingComment "
        class="comment"
      >
        <span 
          v-if="comment"
          class="textSecondary--text"
          >"{{ comment }}"
        </span>
      </div>
      <ValidationObserver
        v-else
        ref="commentObserver"
        v-slot="{ invalid }"
        tag="div"
        name="commentObserver"
        class="w-100 d-flex"
        :class="{'align-items-center': $vuetify.breakpoint.xs}"
      >
        <ValidationProvider
          ref="comment"
          v-slot="{ errors, ariaInput }"
          name="comment"
          :rules="{ max: 150 }"
          class="w-100"
        >
          <VTextarea
            ref="commentArea"
            autofocus
            v-model="comment"
            :rows="$vuetify.breakpoint.xs ? 3 : 1"
            :error-messages="!!errors.length ? validationErrorResolve(errors[0]) : ''"
          />
        </ValidationProvider>
        <VBtn
          class="box-shadow-elevation-6 textPrimary--text grey lighten-4 mx-2"
          :class="{ 'mb-3': $vuetify.breakpoint.xs }"
          fab
          small
          @click="cancel"
        >
          <VIcon v-text="'mdi-close'" dark />
        </VBtn>
        <VBtn
          class="box-shadow-elevation-6 mr-2"
          :class="{ 'mb-3': $vuetify.breakpoint.xs }"
          small
          fab
          :dark="!invalid"
          :disabled="invalid"
          color="green"
          @click="save"
        >
          <VIcon v-text="'mdi-check'" dark />
        </VBtn>
      </ValidationObserver>
    </VCol>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'Comment',
};
</script>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import BookingsService from '@slg/web-customer-shared/src/services/BookingsService';
import { useGlobalErrorDialog, useValidationError, useVuetify } from '../../../../composables';

const props = defineProps({
  trip: {
    type: Object,
    required: true,
  },
  isEditingComment: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['end-edit-comment']);
const { setGlobalError } = useGlobalErrorDialog();
const { validationErrorResolve } = useValidationError();
const vuetify = useVuetify();

const comment = ref('');
const savedComment = ref('');
const commentArea = ref<InstanceType<typeof HTMLElement> | HTMLElement | { $el: HTMLElement } | null>(null);

savedComment.value = props.trip.comment;
comment.value = props.trip.comment;

watch(() => props.isEditingComment, async () => {
  if (props.isEditingComment && vuetify.breakpoint.xs) {
    nextTick(() => {
      (commentArea.value as { $el: HTMLElement }).$el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });
  }
});

async function save() {
  try {
    BookingsService.editComment(props.trip.bookingId, comment.value);
    savedComment.value = comment.value;
    emit('end-edit-comment', comment.value);
  } catch (error) {
    cancel();
    await setGlobalError(error as { errorCode?: string; message?: string });
  }
}

function cancel() {
  comment.value = savedComment.value;
  emit('end-edit-comment', comment.value);
}
</script>

<style scoped>
.comment {
  font-style: italic;
}
</style>
